import { testDataCreator } from '@wix/answers-lib';
import { RoutingFilterType } from '.';
import { RandomGenerator } from '../../test-utils';
export var routingRuleBuilder = testDataCreator(function (props) {
    var _a, _b;
    return ({
        id: (props === null || props === void 0 ? void 0 : props.id) || RandomGenerator.randomId(),
        name: (props === null || props === void 0 ? void 0 : props.name) || RandomGenerator.randomName(),
        filters: ((_b = (_a = props === null || props === void 0 ? void 0 : props.filters) === null || _a === void 0 ? void 0 : _a.filters) === null || _b === void 0 ? void 0 : _b.length) ? props === null || props === void 0 ? void 0 : props.filters : { filters: [routingFilterBuilder()] },
        targetGroupId: (props === null || props === void 0 ? void 0 : props.targetGroupId) || RandomGenerator.randomId(),
        position: (props === null || props === void 0 ? void 0 : props.position) || 0,
        creationDate: Date.now(),
        lastUpdateDate: Date.now()
    });
});
export var routingFilterBuilder = testDataCreator(function (props) {
    return ({
        filterValues: (props === null || props === void 0 ? void 0 : props.filterValues) || [],
        filterType: (props === null || props === void 0 ? void 0 : props.filterType) || RoutingFilterType.LOCALE
    });
});
//# sourceMappingURL=builders.js.map